import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Shield, Users, Zap } from 'lucide-react';
import { Button } from './ui/button';

const PERKS = [
  { icon: Shield, title: 'SOC 2 + SSO', desc: 'Enterprise-grade security with single sign-on, audit logs, and role-based access controls.' },
  { icon: Users, title: 'Dedicated success team', desc: 'A named CSM, weekly office hours, and a private Slack channel with our engineers.' },
  { icon: Zap, title: 'Custom models & quotas', desc: 'Bring your own LLM keys, fine-tune models, or unlock dedicated capacity for huge workloads.' },
  { icon: Building2, title: 'On-prem & VPC', desc: 'Run Transformerus in your own cloud account or on-prem infrastructure for total data control.' },
];

export default function Enterprise() {
  return (
    <section id="enterprise" className="py-24 lg:py-32 bg-neutral-950 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(56,189,248,0.15),transparent_50%),radial-gradient(circle_at_80%_80%,rgba(167,139,250,0.12),transparent_50%)]" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex px-3 py-1 rounded-full bg-white/10 text-xs font-medium text-white/80 mb-5">For Enterprise</span>
            <h2 className="font-display text-4xl lg:text-5xl font-bold tracking-tight">
              Ship faster, with the controls your security team will love.
            </h2>
            <p className="mt-5 text-lg text-neutral-300 max-w-xl">
              Transformerus Enterprise gives your team a private workspace, dedicated infrastructure, and the compliance posture to power mission-critical applications.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/build">
                <Button className="rounded-full bg-white hover:bg-neutral-100 text-neutral-900 h-12 px-6">
                  Talk to sales
                  <ArrowRight className="w-4 h-4 ml-1.5" />
                </Button>
              </Link>
              <Button variant="outline" className="rounded-full bg-transparent border-white/20 text-white hover:bg-white/10 hover:text-white h-12 px-6">
                View security overview
              </Button>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {PERKS.map((p) => (
              <div key={p.title} className="p-5 rounded-2xl bg-white/5 border border-white/10 backdrop-blur hover:bg-white/10 transition-colors">
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center mb-3">
                  <p.icon className="w-5 h-5" />
                </div>
                <h4 className="font-display text-lg font-semibold">{p.title}</h4>
                <p className="mt-1.5 text-sm text-neutral-400 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
